import styled from 'styled-components'
import { Dropdown } from 'antd'

const AntDropdownStyled = styled(Dropdown)``

export default AntDropdownStyled
